import classnames from 'classnames';
import Button from 'components/actions/Button';

import styles from './styles/DataTable.module.scss';

interface TableErrorProps {
    testId?: string;
    header?: string;
    message?: string;
    onClick?(): void;
}

const TableError = ({ testId, header = 'Something went wrong', message, onClick }: TableErrorProps) => (
    <div
        className={classnames(
            styles.DataTableError,
            'width-100pct display-flex gap-10 padding-15 border-style-solid border-width-1 border-color-danger'
        )}
        data-testid={testId}
    >
        <div>
            <span className='rioglyph rioglyph-error-sign text-color-danger text-size-h4 line-height-h4' />
        </div>
        <div>
            <p
                className='padding-top-3 text-bold text-size-16 line-height-16'
                data-testid={testId ? `${testId}-header` : undefined}
            >
                {header}
            </p>
            <p className='margin-top-10 margin-bottom-15 text-size-14 line-height-14'>
                {message ?? 'If this issue persists, please contact the Control Center support team.'}
            </p>
            <Button onClick={onClick} style='danger' data-testid={testId ? `${testId}-button` : undefined}>
                <span className='rioglyph rioglyph-repeat' aria-hidden='true' />
                <span>Refresh table</span>
            </Button>
        </div>
    </div>
);

export default TableError;
